<template>
  <div class="modal-advanced-settings">
    <button
      v-b-toggle.collapse
      class="btn btn-sm btn-block text-left btn-advanced"
    >
      <i class="fa fa-angle-down mr-5" />
      Configurações avançadas
    </button>
    <b-collapse id="collapse">
      <div style="padding: 12px 32px;">
        <span>
          Receber confirmação de venda dos meios de pagamento:
        </span>
        <form-group
          v-model="form.payment_type"
          type="radio"
          id="form.payment_type"
          :errors="errors.payment_type"
          :options="[
            { name: 'Todos os meios de pagamento', id: 'all' },
            { name: 'Somente cartão de crédito', id: 'only_card' }
          ]"
        />
        <span>
          Receber confirmação com o valor:
        </span>
        <form-group
          v-model="form.value_type"
          class="mb-0"
          type="radio"
          id="form.value_type"
          :errors="errors.value_type"
          :options="[
            { name: 'Valor real da venda', id: 'real_value' },
            { name: 'Valor que eu definir', id: 'custom_value' }
          ]"
        />

        <div v-if="form.value_type === 'custom_value'">
          <div
            v-for="(opt, i) in form.custom_value_config.value_by_method"
            :key="`method-value-${i}`"
            class="row align-items-end"
          >
            <div class="col-8 pr-3">
              <action-dispatcher action="product/getPaymentMethods">
                <form-group
                  v-model="opt.payment_method"
                  select
                  id="payment_method_v"
                  placeholder="Selecione..."
                  label="Quando o meio de pagamento for"
                  :options="paymentMethods"
                />
              </action-dispatcher>
            </div>
            <div class="col-4 pl-3">
              <div class="d-flex align-items-end">
                <form-group
                  v-model="opt.value"
                  is-money
                  placeholder="0,00"
                  id="value_payment_method"
                  :money-config="{
                    prefix: ''
                  }"
                />
                <button
                  class="btn text-danger pb-0"
                  @click="removeValueByMethod(i)"
                >
                  <i class="fa-solid fa-trash" />
                </button>
              </div>
            </div>
          </div>
          <button class="btn btn-link" @click="addValueByMethod">
            <i class="fa fa-plus mr-5" /> Adicionar meio de pagamento
          </button>

          <action-dispatcher action="product/getCurrency">
            <form-group
              v-model="form.custom_value_config.currency"
              select
              placeholder="Selecione..."
              id="payment_method_currency"
              label="Enviar valores na moeda"
              :options="currencies"
            />
          </action-dispatcher>
        </div>
      </div>
    </b-collapse>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      advanced: false
    };
  },
  computed: {
    ...mapState("product", ["paymentMethods", "currencies"])
  },
  methods: {
    addValueByMethod() {
      this.form.custom_value_config.value_by_method.push({
        payment_method: "",
        value: ""
      });
    },
    removeValueByMethod(i) {
      this.form.custom_value_config.value_by_method.splice(i, 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-advanced-settings {
  .btn-advanced {
    display: flex;
    padding: 8px 12px;
    justify-content: flex-start;

    font-size: 14px;
    font-weight: 400;
    border-radius: 0;
    line-height: 24px;
    color: rgba(59, 59, 74, 0.9);
    border-bottom: 1px solid rgba(219, 221, 230, 0.85);
    i {
      font-size: 12px;
      line-height: 20px;
      transition: 0.4s all;
      color: rgba(87, 88, 107, 0.88);
    }
  }

  .collapse {
    font-size: 14px;
    line-height: 24px;
    color: rgba(59, 59, 74, 0.9);
    background: rgba(105, 106, 126, 0.04);
  }
  ::v-deep .custom-radio:has(input:checked) {
    .custom-control-label {
      color: #781effe0;
    }
  }
  &:has(.collapse.show) {
    .btn-advanced {
      border-color: transparent;
      background: rgba(105, 106, 126, 0.04) !important;
      i {
        transform: rotate(180deg);
      }
    }
  }
  ::v-deep {
    .form-group {
      padding: 0;
      margin-top: 16px;
      label:not(.custom-control-label) {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 4px;
        color: #736d80;
      }
      .el-input__inner,
      .form-control {
        border: 1px solid #c4c0cc;
        min-height: 40px;
        height: 40px;
      }
    }
  }
  .fa-trash {
    color: #d0000ee0;
  }
  .btn-link {
    color: #360087ed;
  }
}
</style>
